import createDuck from '../../../lib/ducks/remoteDuck'
import Cart from '../../../lib/api/cart'

export default createDuck({
  namespace: 'account',
  store: 'voucher',
  fetchCallback: (options) => Cart.get(options),
})
